import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '@spothero/ui/carousel';
import CarouselSlides from '@spothero/ui/carousel-slides';
import CarouselSlide from '@spothero/ui/carousel-slide';
import NewsFeature from './NewsFeature';

const features = [
    {
        title: 'TIME',
        description:
            'SpotHero is one of 50 Genius Companies inventing the future.',
        imageID: 'time-logo',
        dimensions: {
            height: 40,
            width: 130,
        },
        url:
            'https://time.com/collection/genius-companies-2018/5412656/spothero/',
    },
    {
        title: 'TechCrunch',
        description: 'SpotHero is ready for the future of autonomous parking.',
        imageID: 'techcrunch-logo',
        dimensions: {
            height: 40,
            width: 282,
        },
        url:
            'https://techcrunch.com/2019/07/26/how-parking-app-spothero-is-preparing-for-an-era-of-driverless-cars/',
    },
];

const NewsFeatures = ({className}) => {
    return (
        <>
            <Carousel
                className={classNames(
                    'NewsFeatures',
                    'NewsFeatures-carousel',
                    className
                )}
                showDots
                transition="none"
            >
                <CarouselSlides>
                    {features.map((feature, index) => (
                        <CarouselSlide
                            className="NewsFeatures-item"
                            key={index}
                        >
                            <NewsFeature {...feature} />
                        </CarouselSlide>
                    ))}
                </CarouselSlides>
            </Carousel>
            <div className="NewsFeatures NewsFeatures-static">
                {features.map((feature, index) => (
                    <div className="NewsFeatures-item" key={index}>
                        <NewsFeature {...feature} />
                    </div>
                ))}
            </div>
        </>
    );
};

NewsFeatures.propTypes = {
    className: PropTypes.string,
};

export default NewsFeatures;
